module.exports = __webpack_public_path__ + "img/BackIcon.c89d020e.svg";